export const breakpoints = {
  lg: 1024,
  md: 834,
  sm: 375,
  xl: 1440,
} as const
